import { defineMessages } from 'react-intl-next';

export default defineMessages({
	articleIconLabel: {
		defaultMessage: 'article icon',
		description: 'Default icon label for article',
		id: 'hub-home.hub.link-picker.article.icon-label',
	},
	customPageIconLabel: {
		defaultMessage: 'page icon',
		description: 'Default icon label for page',
		id: 'hub-home.hub.link-picker.custom-page.icon-label',
	},
	portalIconLabel: {
		defaultMessage: 'portal icon',
		description: 'Default icon label for portal',
		id: 'hub-home.hub.link-picker.portal.icon-label',
	},
	requestFormIconLabel: {
		defaultMessage: 'request form icon',
		description: 'Default icon label for request form',
		id: 'hub-home.hub.link-picker.request-form.icon-label',
	},
});
